import {h, createRef} from 'preact';

export default function Search(props) {

  const inputRef = createRef();

  const handleSubmit = (e) => {
    e.preventDefault();
    props.setSearch(inputRef.current.value);
    inputRef
      .current
      .blur();
    return false;
  };

  const searchTitle = props.mode === 'certificates'
    ? 'Search Online Certificate Programs'
    : 'Search Online Programs';

  return (
    <form class="filter__search" onSubmit={handleSubmit}>
      <label class="screen-reader-text" for="filter-search">{Drupal.t(searchTitle)}</label>
      <input
        ref={inputRef}
        id="filter-search"
        type="search"
        autocomplete="off"
        class="filter__search__input"
        placeholder={Drupal.t(searchTitle)}
        value={Drupal.t(props.search)}/>
      <label class="screen-reader-text" for="search-submit">{Drupal.t(searchTitle)}</label>
      <input class="search-submit-button" value={Drupal.t(searchTitle)} type="submit" id="search-submit" />
    </form>

  )
}
